import React from 'react';

const TextfieldFloatingText = (props) =>
    <span className='textfield-floating-text'>
    {props.title}
    {
        props.required === true 
            || props.required === 'true' ? 
                <span className='required'>*</span>
                    : null
    }
</span>;

export default TextfieldFloatingText;


// WEBPACK FOOTER //
// ./src/components/portal/textfieldFloatingText.jsx